// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "sinippet-view" + "." + "4c727ee1" + ".css";
};